class CartRemoveButton extends HTMLElement {
    constructor() {
        super();

        this.addEventListener("click", (event) => {
            event.preventDefault();
            const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();
        this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");

        const debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener("change", debouncedOnChange.bind(this));
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === "cart-items") {
                return;
            }
            this.onCartUpdate();
        });

        this.checkCartCount();

        document.addEventListener("keydown", (event) => {
            if (
                event.target.matches(".quantity__input") &&
                event.key === "Enter"
            ) {
                event.preventDefault();
                this.validateQuantity(event);
            }
        });

        document.querySelectorAll('.cart-remove-button').forEach((button) => {
            button.addEventListener('click', (event) => {
                const variantId = button.getAttribute('data-variant-id');

                this.checkCartCount();
                const variantInput = document.querySelector('input[name="id"]');
                if (variantInput) {
                    if (variantId == variantInput.value) {
                        const submitButton = document.querySelector('button[type="submit"][name="add"]');
                        if (submitButton) {
                            submitButton.setAttribute('data-added-qty', 0);
                        }
                        const errorElement = document.querySelector('.product-form__error-message-wrapper[role="alert"]');
                        if (errorElement) {
                            errorElement.setAttribute('hidden', '');
                        }
                    }
                }
            });
        });
    }

    checkCartCount() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if (cart.item_count === 0) {
                const miniCartIcon = document.getElementById('cart-icon-bubble');
                if (miniCartIcon) {
                    const miniCartCount = miniCartIcon.querySelector('.cart-count-bubble');
                    if (miniCartCount) {
                      miniCartCount.remove();
                    }
                    const bubble = document.createElement('div');
                    bubble.className = 'cart-count-bubble';

                    const span = document.createElement('span');
                    span.className = 'visually-hidden';
                    span.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;

                    bubble.appendChild(span);
                    miniCartIcon.appendChild(bubble);
                }
            } else {
                const sampleHandles = ['swatch-request', 'made-to-order-swyft-swatch-box'];

                // Separate sample items and non-sample items
                let hasSampleItems = false;
                let nonSampleCount = 0;

                cart.items.forEach(item => {
                    if (sampleHandles.includes(item.handle)) {
                        hasSampleItems = true;
                    } else {
                        nonSampleCount += item.quantity;
                    }
                });

                // Sample count is always 1 if any samples exist
                let displayCount = nonSampleCount;
                if (hasSampleItems) {
                    displayCount += 1;
                }

                const miniCartIcon = document.getElementById('cart-icon-bubble');
                if (miniCartIcon) {
                    const existingBubble = miniCartIcon.querySelector('.cart-count-bubble');
                    if (existingBubble) {
                        existingBubble.remove();
                    }

                    if (displayCount > 0) {
                        const bubble = document.createElement('div');
                        bubble.className = 'cart-count-bubble';

                        // Screen-reader text
                        const srText = document.createElement('span');
                        srText.className = 'visually-hidden';
                        srText.textContent = `${displayCount} item${displayCount !== 1 ? 's' : ''}`;
                        bubble.appendChild(srText);

                        // Visible count
                        const visibleNumber = document.createElement('span');
                        visibleNumber.setAttribute('aria-hidden', 'true');
                        visibleNumber.textContent = displayCount;
                        bubble.appendChild(visibleNumber);

                        miniCartIcon.appendChild(bubble);
                    }
                }
            }
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`) || this.querySelector(`#Drawer-quantity-${id}`);
        input.value = input.getAttribute("value");
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();

        setTimeout(() => {
            event.target.setCustomValidity("");
            event.target.reportValidity();
        }, 1500);
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;
        let message = "";
        const stockCheckQty = parseInt(event.target.dataset.stockCheckQty);
        const currentQuantity = parseInt(event.target.getAttribute('value'));

        if (inputValue < event.target.dataset.min) {
            message = window.quickOrderListStrings.min_error.replace("[min]", event.target.dataset.min);
        } else if (inputValue > parseInt(event.target.max)) {
            message = window.quickOrderListStrings.max_error.replace("[max]", event.target.max);
        } else if (inputValue % parseInt(event.target.step) !== 0) {
            message = window.quickOrderListStrings.step_error.replace("[step]", event.target.step);
        } else if ((stockCheckQty != "") && inputValue > stockCheckQty && inputValue > currentQuantity) {
            message = "You've reached the maximum stock."
        }

        if (message) {
            this.setValidity(event, index, message);
        } else {
            event.target.setCustomValidity("");
            event.target.reportValidity();
            this.updateQuantity(index, inputValue, document.activeElement.getAttribute("name"), event.target.dataset.quantityVariantId);
        }
    }

    onChange(event) {
        if (!event.target.classList.contains('text-area')) {
            this.validateQuantity(event);
        }
    }

    onCartUpdate() {
        if (this.tagName === "CART-DRAWER-ITEMS") {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, "text/html");
                    const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
                    for (const selector of selectors) {
                        const targetElement = document.querySelector(selector);
                        const sourceElement = html.querySelector(selector);
                        if (targetElement && sourceElement) {
                            targetElement.replaceWith(sourceElement);
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        } else {
            fetch(`${routes.cart_url}?section_id=main-cart-items`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, "text/html");
                    const sourceQty = html.querySelector("cart-items");
                    this.innerHTML = sourceQty.innerHTML;
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }

    getSectionsToRender() {
        return [
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items").dataset.id,
                selector: ".js-contents",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
            {
                id: "cart-live-region-text",
                section: "cart-live-region-text",
                selector: ".shopify-section",
            },
            {
                id: "main-cart-footer",
                section: document.getElementById("main-cart-footer").dataset.id,
                selector: ".js-contents",
            },
        ];
    }

    updateQuantity(line, quantity, name, variantId) {
        this.enableLoading(line);

        const itemAvailabilityData = this.querySelector(`#CartItem-${line} item-availability`)?.dataset?.stock;
        let stockData = null;
        try {
            stockData = JSON.parse(itemAvailabilityData);
        } catch (error) {
            stockData = null;
        }
        if (stockData && stockData.stock < quantity) {
            let message = window.cartStrings.quantityError.replace("[quantity]", stockData.stock);
            this.updateLiveRegions(line, message);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
            return;
        }

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll(".cart-item");

                if (parsedState.errors) {
                    quantityElement.value = quantityElement.getAttribute("value");
                    this.updateLiveRegions(line, parsedState.errors);
                    return;
                }

                this.classList.toggle("is-empty", parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector("cart-drawer");
                const cartFooter = document.getElementById("main-cart-footer");

                if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section) => {
                    if (section.id === "main-cart-items") {
                        const cartItemsElemetToReplace = document.getElementById(section.id).querySelector(section.selector);
                        cartItemsElemetToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                        
                        const summaryBlockElemetToReplace = document.getElementById(section.id).querySelector(".js-summary-contents");
                        summaryBlockElemetToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], ".js-summary-contents");
                    } else {
                        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                    }

                    const divideBuyElementToReplace = document.getElementById(section.id).querySelector('[data-asset="divide-buy-wrapper"]');
                    if (divideBuyElementToReplace) {
                        divideBuyElementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], '[data-asset="divide-buy-wrapper"]');   
                    }
                });
                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
                const variantInput = document.querySelector('input[name="id"]');
                if (variantInput) {
                    let qty = updatedValue;

                    const submitButton = document.querySelector('button[type="submit"][name="add"]');
                    if (variantId && submitButton && qty) {
                        submitButton.setAttribute('data-added-qty', qty);
                    }
                }

                const errorElement = document.querySelector('.product-form__error-message-wrapper[role="alert"]');
                if (errorElement) {
                    errorElement.setAttribute('hidden', '');
                }

                let message = "";
                if (items.length === parsedState.items.length && quantityElement && updatedValue !== parseInt(quantityElement.value)) {
                    if (typeof updatedValue === "undefined") {
                        message = window.cartStrings.error;
                    } else {
                        message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
                    }
                }
                this.updateLiveRegions(line, message);

                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector(".drawer__inner-empty"), cartDrawerWrapper.querySelector("a"));
                } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector(".cart-item__name"));
                }
                document.querySelector('body').classList.remove('deleting-insurance-item');
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: parsedState, variantId: variantId });

                if (typeof window.freeSampleInit === "function") {
                    window.freeSampleInit();
                } 
            })
            .catch((error) => {
                this.querySelectorAll(".loading__spinner").forEach((overlay) => overlay.classList.add("hidden"));
                const errors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
                errors.textContent = window.cartStrings.error;
            })
            .finally(() => {
                this.disableLoading(line);
            });
    }

    updateLiveRegions(line, message) {
        const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector(".cart-item__error-text").textContent = message;

        this.lineItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Remove-${line} .loading__spinner`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove("hidden"));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Remove-${line} .loading__spinner`);

        cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
    customElements.define(
        "cart-note",
        class CartNote extends HTMLElement {
            constructor() {
                super();

                this.addEventListener(
                    "input",
                    debounce((event) => {
                        const body = JSON.stringify({ note: event.target.value });
                        fetch(`${routes.cart_update_url}`,
                        {
                            ...fetchConfig(),
                            ...{ body }
                        }).then((response) => {
                            return response.text();
                        }).then(() => {
                            const cartNoteFields = document.querySelectorAll('[data-asset="cart-note-field"]');
                            cartNoteFields?.forEach(field => {
                                field.value = event.target.value;
                            });
                        });
                    }, ON_CHANGE_DEBOUNCE_TIMER)
                );
            }
        }
    );
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source === 'cart-items' && event.variantId) {
        const updatedItem = event.cartData.items?.find(item => item?.variant_id == event.variantId);
        const insuranceItemOfUpdatedItem = event.cartData.items?.find(item => item?.properties?._associate_product == updatedItem?.variant_id);
        if (updatedItem && insuranceItemOfUpdatedItem) {
            const insuranceItemIndex = event.cartData.items.findIndex(item => (item.variant_id == insuranceItemOfUpdatedItem.variant_id && item.properties._associate_product == updatedItem.variant_id));
            const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
            document.querySelector(`[data-insurance-item="${insuranceItemOfUpdatedItem.variant_id}-${updatedItem.variant_id}"]`).classList.add('updating')
            cartItems.updateQuantity(insuranceItemIndex+1, updatedItem.quantity, null, `${insuranceItemOfUpdatedItem.variant_id}`);
        }
    } else {
        event.cartData.items.forEach(item => {
            const mainProductId = item?.properties?._associate_product;
            if (mainProductId) {
                const isMainProductExist = event.cartData.items.some(c_item => c_item.variant_id == mainProductId);
                if (isMainProductExist === false) {
                    const invalidinsuranceItemIndex = event.cartData.items.findIndex(i_item => (i_item.variant_id == item.variant_id && mainProductId == item?.properties?._associate_product));
                    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                    document.querySelector('body').classList.add('deleting-insurance-item');
                    cartItems.updateQuantity(invalidinsuranceItemIndex+1, 0);
                }
            }
        });
    }
});